import {
  REDIRECT_PAGE_SELECT,
  completionPageContext,
  loadRedirectPages,
  redirectPageTitle,
} from "#/admin/legacy/assessment-builder/completion-page.js";
import "#legacy/admin/assessment_builder/_generated_templates.js";
import "#legacy/admin/components/wysiwyg.js";
import "#legacy/admin/assessment_builder/views/base.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};

AssessmentBuilder.Views.CompletionPageForm = class CompletionPageForm extends AssessmentBuilder.Views.Base {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.initializeRemoteSelect = this.initializeRemoteSelect.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    return this.listenTo(this.model, "change:type", this.render);
  }

  render() {
    this.$el.html(
      this.template(
        completionPageContext(this.selectTemplateContext(this.model.attributes, { outcomeTypeItems: "outcome_type" })),
      ),
    );
    this.initializeRemoteSelect();
    Sparkle.Components.Wysiwyg.attach(this.$("textarea[name=text]"), { toolset: "extended" });

    return this;
  }

  handlePageChange(event) {
    this.model.set("title", redirectPageTitle(event.target));
  }

  initializeRemoteSelect() {
    return loadRedirectPages(this.el, this.model.get("pageId"));
  }
};
AssessmentBuilder.Views.CompletionPageForm.prototype.tagName = "completion-page-form";
AssessmentBuilder.Views.CompletionPageForm.prototype.className = "assessment-form --view-completion-page";
AssessmentBuilder.Views.CompletionPageForm.prototype.template = _.template(
  AssessmentBuilder.Templates.CompletionPage.form,
);
AssessmentBuilder.Views.CompletionPageForm.prototype.events = {
  'change :input[group="completion-page"], sp-select[group="completion-page"]': "handleAttributeChange",
  [`change ${REDIRECT_PAGE_SELECT}`]: "handlePageChange",
};
